import { useContext } from 'react';
import { TabStatusContext } from '@/shared/TabStatusContext';

export const useTabStatusContext = () => {
  const context = useContext(TabStatusContext);
  if (!context) {
    throw new Error('useTabStatusContext must be used within a TabStatusProvider');
  }
  return { tabStatus: context.tabStatus, refreshTabStatus: context.refreshTabStatus, isLoading: context.isLoading };
};
